import React__default from 'react';
import styled from '../../../../../../node_modules/@mui/material/styles/styled.mjs';

const Image = styled('img')(({ theme })=>({
        '&': {
            alignSelf: 'start',
            maxWidth: 'min(100%, 1200px)',
            margin: `${theme.spacing(1)} 0`,
            display: 'block'
        }
    }));
const Screenshot = ({ src, hasRetina = true, alt })=>{
    return /*#__PURE__*/ React__default.createElement(Image, {
        src: src,
        // We'll assume the image is a png, screenshots should probably not be in any other format
        srcSet: hasRetina ? `${src.replace(/\.png$/, '.2x.png')} 2x` : undefined,
        alt: alt
    });
};

export { Screenshot };
//# sourceMappingURL=Screenshot.mjs.map
